import { Permission } from "models/Permission";
import { AppStore } from "App/Store";

export const allowCompanyRead = (store: AppStore) => {
  const { allowTables } = store.UserToken;
  for (const allowTable of allowTables) {
    const permission = new Permission(allowTable.allow.split(""));
    switch (allowTable.table) {
      case "company":
        if (!permission.isUserReadable() || !permission.isGroupReadable() || !permission.isOtherReadable()) {
          return false;
        }
        break;

      case "company_title":
        if (!permission.isUserReadable()) {
          return false;
        }
        break;
      case "company_users_relation":
        if (!permission.isUserReadable()) {
          return false;
        }
        break;
      case "company_self_relation":
        if (!permission.isUserReadable()) {
          return false;
        }
        break;
      default:
        break;
    }
  }
  return true;
};
